import moment from "moment"
import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetAntrepoInListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    columnChooser: ColumnChooserModel[] | undefined
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    antrepoEnteranceDateStart: string | undefined
    antrepoEnteranceDateEnd: string | undefined
    selectedSenderFirm: CustomSingleSelectModel | undefined
    selectedReceiverFirm: CustomSingleSelectModel | undefined
    selectedDutyFirm: CustomSingleSelectModel | undefined
    selectedCustomsDirectorate: CustomSingleSelectModel | undefined
    selectedExitCountry: CustomSingleSelectModel | undefined
    selectedVehicle: CustomSingleSelectModel | undefined
    selectedTrailer: CustomSingleSelectModel | undefined
    selectedSupplier: CustomSingleSelectModel | undefined
    selectedIsCloseds: CustomMultiSelectModel[]
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetAntrepoInListPagingAndFilterRequest: GetAntrepoInListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnChooser: undefined,
    antrepoEnteranceDateStart: undefined,
    antrepoEnteranceDateEnd: undefined,
    selectedSenderFirm: undefined,
    selectedReceiverFirm: undefined,
    selectedDutyFirm: undefined,
    selectedCustomsDirectorate: undefined,
    selectedExitCountry: undefined,
    selectedVehicle: undefined,
    selectedTrailer: undefined,
    selectedSupplier: undefined,
    // Açılıştaki "Açık Beyanname" varsayılanı artık Beyanname Durumu kolon filtresinde (AntrepoInList).
    selectedIsCloseds: [],
    columnFilters: []
}